import $ from 'wee-dom';
import $screen from 'wee-screen';
import $events from 'wee-events';
import Tabbable from '../../../scripts/tabbable';
import KeyHelper from '../../../scripts/keyhelper';
import Tweezer from 'tweezer.js'
import { open, disabled } from '../../../scripts/classes';

export default class TabbedContent {
    constructor(parent, scrollTo = false) {
        this.$parent = $(parent);
        this.$openTab = null;
        this.$activeButton = null;
        this.$container = this.$parent.find(':tabContainer');
        this.$arrow = this.$parent.find(':arrow');
        this.$buttonsWrapper = this.$parent.find(':tabButtons');
        this.$tab = this.$parent.find(':tab');
        this.$action = this.$parent.find(':tabAction');
        this.$open = this.$parent.find(':open');
        this.maxLength = this.$parent.find(':open').length - 1;
        this.$close = this.$parent.find(':close');
        this.isExpandable = this.$parent.data('expandable');
        this.$title = this.$parent.find(':tabTitle');
        this.tabbable = null;
        this.scrollTo = scrollTo;
    }

    // Set open tab
    setTab(tab) {
        if (this.$activeButton) {
            this.$activeButton.deactivate();
        }

        this.$activeButton = $(tab);
        this.$activeButton.activate();

        this.openTab(tab, this.$activeButton.data('id'));
    }

    // Swap current tab for clicked tab
    openTab(tab, tabId) {
        this.$activeButton.activate();

        if (this.$openTab) {
            this.$openTab.hide();
        } else {
            this.$container.ariaExpand();
        }

        $screen.map({
            max: 3,
            callback: () => {
                this.scrollTab();
            },
        });

        this.$openTab = this.$parent.find(':' + tabId);

        if (this.$parent.data('locations')) {
            this.scroll(tab);
        }

        const $tab = $(tab);

        if ($tab.data('tab-title') && this.$title.length) {
            this.$title.text($tab.data('tab-title'));
        }

        if (! this.$container.hasClass(open)) {
            this.$container.addClass(open);
            this.$container.show();
        }

        this.$openTab.show();
        this.setArrows();

        this.setAria();

        if (this.isExpandable) {
            this.tabbing();
        }
    }

    // Scroll clicked tab into view
    scrollTab() {
        let scrollWidth = 0;

        this.$open.each((el) => {
            const $el = $(el);

            if ($el.index() < this.$activeButton.index()) {
                scrollWidth += $el.width();
            }
        });

        new Tweezer({
            start: this.$buttonsWrapper.scrollLeft(),
            end: scrollWidth - 30,
            duration: 250,
        }).on('tick', (value) => {
            this.$buttonsWrapper.scrollLeft(value);
        }).begin();
    }

    // Close tab
    close() {
        if (this.$close.length) {
            this.$container.hide()
                .removeClass(open)
                .ariaExpand(false);
            this.$openTab.hide();
            this.$openTab = null;
            this.$activeButton.deactivate();
            this.$activeButton = null;
        }
    }

    // Show previous tab
    prev(el, arrow = false) {
        if (this.$openTab.index() > 0) {
            this.iterate(this.$activeButton.index() - 1, arrow);
        } else {
            this.iterate(this.maxLength, arrow);
        }
    }

    // Show next tab
    next(el, arrow = false) {
        if (this.$openTab.index() < this.maxLength) {
            this.iterate(this.$activeButton.index() + 1, arrow);
        } else {
            this.iterate(0, arrow);
        }
    }

    // Move to next or previous tab
    iterate(i, arrow = false) {
        this.$openTab.hide();
        this.$openTab = this.$container.find(':tab').eq(i);
        this.$openTab.show();

        this.setArrows(i);

        this.$activeButton.deactivate();
        this.$activeButton = this.$parent.find(':tabButtons').find(':tabAction').eq(i);
        this.$activeButton.activate();

        this.setAria();

        if (this.isExpandable) {
            this.tabbing();
        }

        if (this.$parent.data('locations')) {
            this.scroll();
        }
    }

    scroll(tab) {
        $screen.map({
            max: 2,
            callback: () => {
                $(tab).after(this.$container);
            },
        });

        if (this.scrollTo) {
            $(this.$activeButton).find(':tabTitle')[0]
                .scrollIntoView({ behavior: 'smooth', inline: 'end', block: 'start' });
        }
    }

    setAria() {
        this.$tab.aria('hidden', true);
        this.$openTab.aria('hidden', false);

        this.$action.aria('selected', false);
        this.$activeButton.aria('selected', true);
    }

    tabbing() {
        this.tabbable = new Tabbable({
            el: this.$container,
            callback: () => {
                this.$activeButton[0].focus();
            },
        });

        $events.on(this.$open, 'keydown', (e) => {
            if (this.$openTab && KeyHelper.isTab(e)) {
                e.preventDefault();
                this.tabbable.$firstEl[0].focus();
            }
        });

        $events.on(this.$close, 'keyup', (e) => {
            if (KeyHelper.isTab(e)) {
                e.preventDefault();
            }
        });

        $events.on(this.$close, 'keydown', (e) => {
            if (KeyHelper.isShiftTab(e)) {
                e.preventDefault();
                this.$activeButton[0].focus();
            }
        });
    }

    setArrows(i) {
        let index = i;

        if (index === undefined) {
            index = this.$openTab.index();
        }

        if (index === 0) {
            this.getAction('prev').addClass(disabled);
        } else if (index > 0 && index < this.maxLength) {
            this.getAction('next').removeClass(disabled);
            this.getAction('prev').removeClass(disabled);
        } else if (index === this.maxLength) {
            this.getAction('next').addClass(disabled);
        }
    }

    getAction(action) {
        return this.$action.filter((i, el) => $(el).data('event') === action);
    }
}
